import React, { useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import { changePassword } from "../../store/actions/settings";


const Settings = () => {
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
  });
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [error, setError] = useState(false)
  const dispatch = useDispatch();

  const isDisabled = useMemo(() => {
    setErrorMsg('')
    if (passwordData.currentPassword.length !== 6) return true;
    if (passwordData.newPassword.length !== 6) return true;
    if (confirmPassword.length !== 6) return true;

    

    if (passwordData.newPassword !== confirmPassword) {
      setErrorMsg("New passwords do not match");
      return true;
    }

    setErrorMsg("");
    return false;
  }, [passwordData, confirmPassword]);

  const numericOnly = (value) => value.replace(/\D/g, "");

  const handlePasswordChange = () =>{
    dispatch(changePassword(passwordData.currentPassword, passwordData.newPassword))
  }


  return (
    <div className="settings-container">
      <h1>Settings</h1>
      <div className="divider"></div>
      <h3>Change Password</h3>

      <div className="change-password">
        {errorMsg && <p className="error-msg">{errorMsg}</p>}

        {/* Current Password */}
        <div className="input-fields-wrapper">
          <input
            value={passwordData.currentPassword}
            onChange={(e) =>
              setPasswordData({
                ...passwordData,
                currentPassword: numericOnly(e.target.value),
              })
            }
            className="input-field"
            type="password"
            placeholder="Current Password"
            maxLength={6}
            inputMode="numeric"
          />
        </div>

        {/* New Password */}
        <div className="input-fields-wrapper">
          <input
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(numericOnly(e.target.value))}
            className="input-field"
            type="password"
            placeholder="New Password"
            maxLength={6}
            inputMode="numeric"
          />
        </div>

        {/* Confirm Password */}
        <div className="input-fields-wrapper">
          <input
            value={passwordData.newPassword}
          onChange={(e) =>
            setPasswordData({
              ...passwordData,
              newPassword: numericOnly(e.target.value),
            })
            }
            className="input-field"
            type="password"
            placeholder="Confirm New Password"
            maxLength={6}
            inputMode="numeric"
          />
        </div>

        <button disabled={isDisabled} className={isDisabled ? "disable-btn" : ""} onClick={handlePasswordChange}>
          Change Password
        </button>
      </div>
    </div>
  );
};

export default Settings;
